exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/**\n * Mixins\n */\n.uk-button-danger {\n  font-size: 15px; }\n\n.edit-review {\n  /*.language-error{\n    @include font-size(14);\n    margin-top: 15px;\n    color: red;\n  }*/ }\n  .edit-review .uk-button {\n    font-size: 15px; }\n\n.pt-10 {\n  padding-top: 10px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/app/components/reviews/review-view/review-view.component.scss
// module id = ../../../../../src-admin/app/components/reviews/review-view/review-view.component.scss
// module chunks = main